import React from 'react';
import type PlanSettingsCustomFieldsType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/custom-fields/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/**
 * Plan Settings - custom fields page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSettingsCustomFields = lazyForPaint<typeof PlanSettingsCustomFieldsType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-settings-custom-fields", jiraSpaEntry: "async-plan-settings-custom-fields" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/custom-fields'
			),
		),
	{ ssr: false },
);

const AsyncPlanSettingsCustomFields = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanSettingsCustomFields}
		pageId="plan-settings-custom-fields"
		shouldShowSpinner
	/>
);

export default AsyncPlanSettingsCustomFields;
